import { Rout_ActionRoutes } from './Rout.action'
import { Rout_ActivityRoutes } from './Rout.activity'
import { Rout_EventRoutes } from './Rout.event'
import { Rout_FlowRoutes } from './Rout.flow'
import { Rout_GuideRoutes } from './Rout.guide'
import { Rout_LocationRoutes } from './Rout.location'
import { Rout_PlannerRoutes } from './Rout.planner'
import { Rout_PostRoutes } from './Rout.post'
import { Rout_ProcedureRoutes } from './Rout.procedure'
import { Rout_ReportRoutes } from './Rout.report'
import { Rout_SearchRoutes } from './Rout.search'
import { Rout_SettingsRoutes } from './Rout.settings'
import { Rout_SmartDataRoutes } from './Rout.smartdata'
import { Rout_ToDoRoutes } from './Rout.todo'
import { Rout_to } from './Rout'
import { Rout_UnitRoutes } from './Rout.unit'
import { Rout_create } from './Rout.create'
import { router } from './Rout.router'
import { Rout_NotificationRoutes } from './Rout.notification'
import { lazyPages } from './Rout.lazyPages'
import { Rout_NoteRoutes } from './Rout.note'
import { Rout_UserPageRoutes } from './Rout.user'

export const Rout_AppRouter = () =>
    router([
        Rout_ActivityRoutes(lazyPages),
        Rout_EventRoutes(lazyPages),
        Rout_FlowRoutes(lazyPages),
        Rout_GuideRoutes(lazyPages),
        Rout_LocationRoutes(lazyPages),
        Rout_NoteRoutes(lazyPages),
        Rout_PlannerRoutes(lazyPages),
        Rout_PostRoutes(lazyPages),
        Rout_ProcedureRoutes(lazyPages),
        Rout_ReportRoutes(lazyPages),
        Rout_ActionRoutes(lazyPages), // Has to be below report route
        Rout_SettingsRoutes(lazyPages),
        Rout_SmartDataRoutes(lazyPages),
        Rout_ToDoRoutes(lazyPages),
        Rout_UnitRoutes(lazyPages),
        Rout_UserPageRoutes(lazyPages),
        Rout_SearchRoutes(lazyPages),
        Rout_NotificationRoutes(lazyPages),
        Rout_create('/leaderboard', lazyPages.Gami_Leaderboard),
        Rout_create('/invite', lazyPages.Invi_App),
        Rout_create('/playground(/:component)', lazyPages.UI_Playground),
    ])

export function Rout_toLeaderboard() {
    Rout_to(`/leaderboard`)
}

export function Rout_toInvite() {
    Rout_to(`/invite`)
}

export function Rout_toPlayground(component: string) {
    Rout_to(`/playground/${component}`)
}
